"use strict";

(function () {
  // custom event polyfill
  if (typeof window.CustomEvent !== 'function') {
    var CustomEvent = function CustomEvent(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  } // insided js api


  var cookieLevels = ['required', 'anonymous', 'all'];

  var getCookieValue = function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  };

  var setCookieLevels = function setCookieLevels(levels) {
    cookieLevels = levels;
  };

  var getPrivacyLevel = function getPrivacyLevel() {
    return getCookieValue('cookiePrivacyLevel');
  };

  var isAllowed = function isAllowed(level) {
    return cookieLevels.indexOf(getPrivacyLevel()) >= cookieLevels.indexOf(level);
  };

  var addElement = function addElement(params) {
    var tag = document.createElement(params.tag);
    delete params.tag;

    for (var param in params) {
      tag.setAttribute(param, params[param]);
    }

    document.head.appendChild(tag);
  };

  var addTag = function addTag(params) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

    if (!params.tag || !isAllowed(level)) {
      return;
    }

    if (params.tag === 'script') {
      return addScript(params, level);
    }

    addElement(params);
  };

  var addScript = function addScript(params) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

    if (!params.src || !isAllowed(level)) {
      return;
    }

    params.tag = 'script';
    addElement(params);
  };

  var addGA = function addGA(id) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
    var src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    addScript({
      src: src,
      async: true
    }, level);
    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return window.dataLayer.push(args);
    };

    window.gtag('js', new Date());
    window.gtag('config', id);
  };

  var api = {
    addGA: addGA,
    addScript: addScript,
    addTag: addTag,
    getPrivacyLevel: getPrivacyLevel,
    setCookieLevels: setCookieLevels
  };
  var ce = new window.CustomEvent('insided:loaded', {
    detail: api
  });
  document.dispatchEvent(ce);
})();